import { PREDEFINED_QUERIES } from '@app/config/media-queries';
import { useEffect, useState } from 'react';

export function useMatchMedia(query: string) {
  const [matchesWithQuery, setMatchesWithQuery] = useState(false);

  useEffect(() => {
    const mediaQueryList = window.matchMedia(query);
    setMatchesWithQuery(mediaQueryList.matches);

    if (mediaQueryList.addEventListener) mediaQueryList.addEventListener('change', handleMediaChange);
    else mediaQueryList.addListener(handleMediaChange); // Use to support safari browser

    return () => {
      if (mediaQueryList.removeEventListener) mediaQueryList.removeEventListener('change', handleMediaChange);
      else mediaQueryList.removeListener(handleMediaChange);
    };

    function handleMediaChange(event: MediaQueryListEvent) {
      setMatchesWithQuery(event.matches);
    }
  }, [query]);

  return matchesWithQuery;
}

export function useIsTabletOrMobileScreenSize() {
  const matches = useMatchMedia(`(${PREDEFINED_QUERIES.isTabletOrLess})`);
  return matches;
}

export function useIsMobileScreenSize() {
  const matches = useMatchMedia(`(${PREDEFINED_QUERIES.isMobile})`);
  return matches;
}
